import imageRegistry from "./imageRegistry";

export const DATE_TIME_FORMAT = Object.freeze({
  LLLL: "dddd MMMM Do YYYY",
  YYDM: "MM-DD-YY HH:mm",
  YYYYMMDD: "YYYYMMDD",
  LL: "ll",
  YYYY_MM_DDTHH: "YYYY-MM-DDTHH:mm:ss.SSSZ",
  YYYY_MM_DD: "YYYY-MM-DD",
  HH_MM: "hh:mm a",
  LLL: "lll",
  MM_YY: "MMMM YY",
  YYYYMMDDTHHmmss: "YYYYMMDDTHHmmss",
  MM_DD_YYYY_H_M: "MM-DD-YYYY HH:mm",
  HH_M: "HH:mm",
  APPOINTMENT_DATETIME_DATE_PREVIEW: "dddd, MMM D",
  APPOINTMENT_DATETIME_TIME_PREVIEW: "h:mm a",
  MM_DD_YYYY: "MM/DD/YYYY",
  YYYY_MM_DD_HH_mm: "YYYY-MM-DD HH:mm",
  MMMDth_H_MM_A: "MMM D[th], h:mm A",
  MMM: "MMM",
  D: "D",
  DDDD: "dddd",
  DD_MM_YYYY: "DD/MM/YYYY",
  MM_DD_YYYY_dash: "MM-DD-YYYY",
});

export const PAYMENT_METHODS = Object.freeze({
  CREDIT_CARD: "credit_card",
  PAYPAL: "pay_pal_account",
});

export const EVENT_LISTENERS = Object.freeze({
  RESIZE: "resize",
});

export const DEFAULT_IMG_URL =
  "https://app.caradvise.com/static/media/placeholder_car.fcab19be.svg";

const { ChryslerLogo, DodgeLogo, JeepLogo, RamLogo, FiatLogo } = imageRegistry;
export const STELLANTIS_BRANDS = [
  ChryslerLogo,
  DodgeLogo,
  JeepLogo,
  RamLogo,
  FiatLogo,
];

export const MD_HD_VEHICLE_TYPE_ID = 10;

export const DEFAULT_MAP_STYLE = "mapbox://styles/mapbox/streets-v12";

export const TOASTIFY_STATUS = Object.freeze({
  error: "error",
  success: "success",
  warning: "warning",
});

export const MONTH = "month";
